import { FC } from 'react'
import { Format } from 'services/Dates'
import { getPositionName, getProjectName } from 'services/Utilities'

type Props = {
  transfers: MData.PunchCard['transfers']
}
const Transfers: FC<Props> = ({ transfers }) => {
  if (!Array.isArray(transfers)) return null

  return (
    <>
      {transfers.map(({ time, toPosition, toProject }, index) => (
        <div key={index} className="mb-1 text-nowrap">
          <span>
            {Format(time, { outFormat: 'time' })}
            <i className="fad fa-exchange-alt mx-2"></i>
            {!!toPosition && getPositionName(toPosition)}
            {!!toProject && getProjectName(toProject)}
          </span>
        </div>
      ))}
    </>
  )
}

export default Transfers
